import React from 'react';

import { css, merge } from 'glamor';

export default (props = {}) => (
  <svg { ...merge(css({display: 'block', width: props.width || 38, height: props.height || 55 }), {...props}) } xmlns="http://www.w3.org/2000/svg" width="38" height="55" viewBox="0 -1 42 59">
    <defs>
      <filter id="a" width="126%" height="126%" x="-8%" y="-8%" filterUnits="objectBoundingBox">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5"/>
        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#a)" transform="translate(-5 -2)">
      <path stroke="#FFF" strokeLinecap="round" strokeWidth="4" d="M52 30L8 56M8 4l44 26M8 4v52"/>
      <path fill="#FFF" d="M8.779 6L50 30.258 8 56z"/>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ../src/client/components/icons/VideoPlay.js